import JsonObjectInspector from "../validators/JsonObjectInspector";
import SessionDataStorer from "../../dataAccessLayer/session/SessionDataStorer";
import SessionKey from "../../dataAccessLayer/session/SessionKey";



function fetchMethod(url, options, responseCallback) {
    
    fetch(url, options)
        .then(function (httpResponse) {
            //console.log('httpResponse:', httpResponse);
            processSetCsrfTokenSession(httpResponse);
            return httpResponse.text();
        })
        .then(function (responseText) {
            //console.log('responseText:', responseText);
            var responseObj = JsonObjectInspector.safeJsonParse(responseText);
            //console.log('responseObj:', responseObj);

            responseCallback(responseObj);

        })
        .catch(function (error) {
            var errorObj = new Error("Promise Error:" + error);
            //console.log(errorObj);
        })
}

//#region Private Functions BEGIN

function processSetCsrfTokenSession(httpResponse){
    // This will show you exactly which headers are visible to your JS
    for (let [key, value] of httpResponse.headers.entries()) {
        //console.log("Visible Header:", key, value);
    }
    
    const csrfTokenKey = httpResponse.headers.get(SessionKey.x_csrf_token_key_); 
    if (csrfTokenKey) {
        const properties = { path: '/', sameSite: 'Lax' };
        SessionDataStorer.insertSessionInCookieStorage(SessionKey.x_csrf_token_key_, csrfTokenKey, properties );
    }

    const csrfTokenClient = httpResponse.headers.get(SessionKey.x_csrf_token_client);
    if(csrfTokenClient){
        const properties = { path: '/', sameSite: 'Lax' };
        SessionDataStorer.insertSessionInCookieStorage(SessionKey.x_csrf_token_client, csrfTokenClient, properties );
    }    
}

//#region Private Functions END

const FetchAPI = Object.freeze({
    fetchMethod : fetchMethod
});

export default FetchAPI;